import { render, staticRenderFns } from "./mortgage-analyzer-container.vue?vue&type=template&id=052cd0cc"
import script from "./mortgage-analyzer-container.vue?vue&type=script&lang=ts"
export * from "./mortgage-analyzer-container.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports